import React, { useEffect, useState } from 'react';
import { LoggedInNav } from '../components/LoggedInNav';
import { MeetingTabs } from '../components/MeetingTabs';
import { CalendarIcon, SearchIcon, FilterIcon, UsersIcon, ClipboardIcon, ClockIcon, MapPinIcon, CheckCircleIcon, ExternalLinkIcon, ChevronRightIcon, MailIcon } from 'lucide-react';
export function PrepCentre() {
  const [expandedMeeting, setExpandedMeeting] = useState<string | null>('meeting1');
  const [viewMode, setViewMode] = useState<'list' | 'tabs'>('list');
  const [loading, setLoading] = useState(true);
  // Simulate loading for 2 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  const toggleMeeting = (id: string) => {
    setExpandedMeeting(expandedMeeting === id ? null : id);
  };
  if (loading) {
    return <div className="w-full h-screen bg-[#1E2A38] flex items-center justify-center" data-id="element-2577">
        <div className="relative" data-id="element-2578">
          {/* Holographic brief card */}
          <div className="w-96 h-64 relative" data-id="element-2579">
            {/* Holographic container */}
            <div className="absolute inset-0 bg-[#C8F169] bg-opacity-5 rounded-xl border border-[#C8F169] border-opacity-20 backdrop-blur-sm overflow-hidden" data-id="element-2580">
              {/* Scan lines */}
              <div className="absolute inset-0 overflow-hidden" data-id="element-2581">
                <div className="h-full w-full opacity-20" data-id="element-2582">
                  {Array.from({
                  length: 20
                }).map((_, i) => <div key={i} className="h-px bg-[#C8F169] w-full" style={{
                  marginTop: `${i * 10}px`
                }} data-id="element-2583"></div>)}
                </div>
              </div>
              {/* Moving scan line */}
              <div className="absolute top-0 left-0 right-0 h-20 bg-gradient-to-b from-[#C8F169] to-transparent opacity-10 animate-scanline" data-id="element-2584"></div>
              {/* Holographic content - blurred and glitchy */}
              <div className="p-6 relative" data-id="element-2585">
                <div className="flex items-center space-x-4 mb-6 opacity-80" data-id="element-2586">
                  <div className="w-10 h-10 rounded-full bg-[#C8F169] bg-opacity-30" data-id="element-2587"></div>
                  <div data-id="element-2588">
                    <div className="h-5 w-40 bg-[#C8F169] bg-opacity-30 rounded-md mb-2" data-id="element-2589"></div>
                    <div className="h-3 w-32 bg-[#C8F169] bg-opacity-20 rounded-md" data-id="element-2590"></div>
                  </div>
                </div>
                <div className="space-y-4 opacity-70" data-id="element-2591">
                  <div className="h-3 w-full bg-[#C8F169] bg-opacity-20 rounded-md" data-id="element-2592"></div>
                  <div className="h-3 w-full bg-[#C8F169] bg-opacity-20 rounded-md" data-id="element-2593"></div>
                  <div className="h-3 w-3/4 bg-[#C8F169] bg-opacity-20 rounded-md" data-id="element-2594"></div>
                </div>
                <div className="mt-6 space-y-3 opacity-60" data-id="element-2595">
                  <div className="h-8 bg-[#C8F169] bg-opacity-10 rounded-md" data-id="element-2596"></div>
                  <div className="h-8 bg-[#C8F169] bg-opacity-10 rounded-md" data-id="element-2597"></div>
                </div>
              </div>
            </div>
            {/* Holographic projector effect */}
            <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 w-20 h-20" data-id="element-2598">
              <div className="w-full h-full relative" data-id="element-2599">
                <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-8 h-2 bg-[#C8F169] rounded-full filter blur-sm" data-id="element-2600"></div>
                <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-b-16 border-l-transparent border-r-transparent border-b-[#C8F169] opacity-30" data-id="element-2601"></div>
              </div>
            </div>
            {/* Glitch effects */}
            <div className="absolute inset-0 overflow-hidden" data-id="element-2602">
              <div className="absolute h-2 w-full bg-[#C8F169] bg-opacity-40 top-1/4 left-0 transform -translate-y-1/2 animate-pulse" data-id="element-2603"></div>
              <div className="absolute h-1 w-full bg-[#C8F169] bg-opacity-40 top-3/4 left-0 transform -translate-y-1/2 animate-pulse delay-300" data-id="element-2604"></div>
            </div>
          </div>
          {/* Loading text */}
          <div className="text-center mt-8" data-id="element-2605">
            <p className="text-[#C8F169] text-opacity-80 font-mono text-sm animate-pulse" data-id="element-2606">
              Initializing Prep Centre...
            </p>
          </div>
          {/* Ambient glow */}
          <div className="absolute -inset-20 bg-[#C8F169] opacity-5 blur-3xl rounded-full" data-id="element-2607"></div>
        </div>
      </div>;
  }
  return <div className="w-full min-h-screen bg-[#1E2A38] text-[#F5F7FA] font-sans" data-id="element-2608">
      <LoggedInNav data-id="element-2609" />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2610">
        <div className="flex justify-between items-center mb-8" data-id="element-2611">
          <h1 className="text-2xl font-bold" data-id="element-2612">Prep Centre</h1>
          <div className="flex space-x-4" data-id="element-2613">
            <div className="relative" data-id="element-2614">
              <input type="text" placeholder="Search meetings..." className="bg-[#F5F7FA] bg-opacity-5 border border-[#F5F7FA] border-opacity-10 rounded-lg py-2 pl-10 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#C8F169] focus:ring-opacity-50" data-id="element-2615" />
              <SearchIcon className="absolute left-3 top-2.5 h-4 w-4 text-[#F5F7FA] text-opacity-50" data-id="element-2616" />
            </div>
            <button className="bg-[#F5F7FA] bg-opacity-5 border border-[#F5F7FA] border-opacity-10 rounded-lg p-2" data-id="element-2617">
              <FilterIcon className="h-5 w-5 text-[#F5F7FA] text-opacity-70" data-id="element-2618" />
            </button>
            <div className="flex rounded-lg overflow-hidden border border-[#F5F7FA] border-opacity-10" data-id="element-2619">
              <button className={`px-3 py-1 ${viewMode === 'list' ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'bg-[#F5F7FA] bg-opacity-5 text-[#F5F7FA] text-opacity-70'}`} onClick={() => setViewMode('list')} data-id="element-2620">
                List View
              </button>
              <button className={`px-3 py-1 ${viewMode === 'tabs' ? 'bg-[#C8F169] bg-opacity-20 text-[#C8F169]' : 'bg-[#F5F7FA] bg-opacity-5 text-[#F5F7FA] text-opacity-70'}`} onClick={() => setViewMode('tabs')} data-id="element-2621">
                Detailed View
              </button>
            </div>
          </div>
        </div>
        {viewMode === 'tabs' ? <div className="mb-8" data-id="element-2622">
            <MeetingTabs data-id="element-2623" />
          </div> : <div className="space-y-6" data-id="element-2624">
            <div className="bg-[#F5F7FA] bg-opacity-5 p-6 rounded-xl" data-id="element-2625">
              <div className="flex items-center justify-between mb-4" data-id="element-2626">
                <div className="flex items-center space-x-4" data-id="element-2627">
                  <CalendarIcon className="h-6 w-6 text-[#C8F169]" data-id="element-2628" />
                  <h2 className="text-xl font-medium" data-id="element-2629">Today</h2>
                </div>
                <span className="bg-[#C8F169] bg-opacity-20 px-3 py-1 rounded-full text-sm text-[#C8F169]" data-id="element-2630">
                  3 Meetings
                </span>
              </div>
              <div className="space-y-4" data-id="element-2631">
                {/* First meeting card */}
                <div className={`bg-[#1A2331] rounded-lg border ${expandedMeeting === 'meeting1' ? 'border-[#C8F169] border-opacity-30' : 'border-[#F5F7FA] border-opacity-5 hover:border-[#C8F169] hover:border-opacity-30'} transition-all cursor-pointer`} onClick={() => toggleMeeting('meeting1')} data-id="element-2632">
                  <div className="p-5" data-id="element-2633">
                    <div className="flex items-center justify-between mb-3" data-id="element-2634">
                      <div className="flex items-center space-x-3" data-id="element-2635">
                        <div className="w-10 h-10 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-sm font-bold" data-id="element-2636">
                          WS
                        </div>
                        <div data-id="element-2637">
                          <div className="font-medium text-lg" data-id="element-2638">
                            Quarterly Strategy Meeting
                          </div>
                          <div className="flex items-center text-sm text-[#F5F7FA] text-opacity-60" data-id="element-2639">
                            <ClockIcon className="h-3.5 w-3.5 mr-1" data-id="element-2640" />
                            10:00 AM - 11:30 AM
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2" data-id="element-2641">
                        <div className="bg-[#4A5A6A] bg-opacity-50 px-3 py-1.5 rounded-full" data-id="element-2642">
                          <span className="text-xs font-medium text-[#F5F7FA]" data-id="element-2643">
                            Important
                          </span>
                        </div>
                        <div className="bg-[#C8F169] bg-opacity-20 px-3 py-1.5 rounded-full" data-id="element-2644">
                          <span className="text-xs font-medium text-[#C8F169]" data-id="element-2645">
                            Preparation Ready
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {expandedMeeting === 'meeting1' && <div className="px-5 pb-5 border-t border-[#F5F7FA] border-opacity-10 pt-4" data-id="element-2646">
                      <div className="space-y-6" data-id="element-2647">
                        <div data-id="element-2648">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-2" data-id="element-2649">
                            Meeting Brief
                          </h3>
                          <p className="text-[#F5F7FA]" data-id="element-2650">
                            This quarterly strategy meeting will focus on
                            reviewing Q3 results and planning for Q4
                            initiatives. The team will discuss current project
                            status, resource allocation, and upcoming market
                            opportunities.
                          </p>
                        </div>
                        <div data-id="element-2651">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2652">
                            Attendees (5)
                          </h3>
                          <div className="space-y-3" data-id="element-2653">
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2654">
                              <div className="flex items-center space-x-3" data-id="element-2655">
                                <div className="w-8 h-8 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2656">
                                  WS
                                </div>
                                <div data-id="element-2657">
                                  <div className="font-medium" data-id="element-2658">
                                    William Smith
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2659">
                                    VP of Product, TechCorp
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2660">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2661" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2662">
                              <div className="flex items-center space-x-3" data-id="element-2663">
                                <div className="w-8 h-8 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2664">
                                  AJ
                                </div>
                                <div data-id="element-2665">
                                  <div className="font-medium" data-id="element-2666">
                                    Alice Johnson
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2667">
                                    Director of Marketing, TechCorp
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2668">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2669" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2670">
                              <div className="flex items-center space-x-3" data-id="element-2671">
                                <div className="w-8 h-8 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2672">
                                  RB
                                </div>
                                <div data-id="element-2673">
                                  <div className="font-medium" data-id="element-2674">
                                    Robert Brown
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2675">
                                    Sales Manager, TechCorp
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2676">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2677" />
                                LinkedIn
                              </button>
                            </div>
                            <button className="flex items-center text-[#C8F169] text-sm" data-id="element-2678">
                              View all 5 attendees
                              <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-2679" />
                            </button>
                          </div>
                        </div>
                        <div data-id="element-2680">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2681">
                            Previous Engagement
                          </h3>
                          <div className="space-y-3" data-id="element-2682">
                            <div className="bg-[#1E2A38] p-3 rounded-lg" data-id="element-2683">
                              <div className="flex items-start space-x-3" data-id="element-2684">
                                <MailIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2685" />
                                <div data-id="element-2686">
                                  <h4 className="font-medium" data-id="element-2687">
                                    Q3 Results Discussion with William Smith
                                  </h4>
                                  <p className="text-sm text-[#F5F7FA] text-opacity-70 mt-1" data-id="element-2688">
                                    William shared the Q3 performance metrics,
                                    highlighting a 27% growth in user
                                    acquisition. He requested preparation for
                                    questions about the marketing budget
                                    allocation for Q4.
                                  </p>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-50 mt-2" data-id="element-2689">
                                    3 days ago
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-2690">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2691">
                            Business Insights
                          </h3>
                          <div className="space-y-3" data-id="element-2692">
                            <div className="flex items-start space-x-3" data-id="element-2693">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2694" />
                              <p className="text-[#F5F7FA]" data-id="element-2695">
                                Company grew 27% in Q3, exceeding the market
                                average of 18%
                              </p>
                            </div>
                            <div className="flex items-start space-x-3" data-id="element-2696">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2697" />
                              <p className="text-[#F5F7FA]" data-id="element-2698">
                                New product launch scheduled for early Q4 with
                                85% readiness
                              </p>
                            </div>
                            <div className="flex items-start space-x-3" data-id="element-2699">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2700" />
                              <p className="text-[#F5F7FA]" data-id="element-2701">
                                Customer retention improved by 12% following the
                                last initiative
                              </p>
                            </div>
                          </div>
                          <button className="flex items-center text-[#C8F169] text-sm mt-4" data-id="element-2702">
                            View More
                            <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-2703" />
                          </button>
                        </div>
                        <div className="flex justify-end" data-id="element-2704">
                          <button className="bg-[#C8F169] hover:bg-opacity-90 text-[#1E2A38] px-4 py-2 rounded-lg text-sm font-medium" data-id="element-2705">
                            View Preparation
                          </button>
                        </div>
                      </div>
                    </div>}
                </div>
                {/* Second meeting card */}
                <div className={`bg-[#1A2331] rounded-lg border ${expandedMeeting === 'meeting2' ? 'border-[#C8F169] border-opacity-30' : 'border-[#F5F7FA] border-opacity-5 hover:border-[#C8F169] hover:border-opacity-30'} transition-all cursor-pointer`} onClick={() => toggleMeeting('meeting2')} data-id="element-2706">
                  <div className="p-5" data-id="element-2707">
                    <div className="flex items-center justify-between" data-id="element-2708">
                      <div className="flex items-center space-x-3" data-id="element-2709">
                        <div className="w-10 h-10 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-sm font-bold" data-id="element-2710">
                          AJ
                        </div>
                        <div data-id="element-2711">
                          <div className="font-medium text-lg" data-id="element-2712">
                            Product Demo with Client
                          </div>
                          <div className="flex items-center text-sm text-[#F5F7FA] text-opacity-60" data-id="element-2713">
                            <ClockIcon className="h-3.5 w-3.5 mr-1" data-id="element-2714" />
                            1:00 PM - 2:00 PM
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#F5F7FA] bg-opacity-10 px-3 py-1.5 rounded-full" data-id="element-2715">
                        <span className="text-xs font-medium text-[#F5F7FA] text-opacity-70" data-id="element-2716">
                          Preparation Read
                        </span>
                      </div>
                    </div>
                  </div>
                  {expandedMeeting === 'meeting2' && <div className="px-5 pb-5 border-t border-[#F5F7FA] border-opacity-10 pt-4" data-id="element-2717">
                      <div className="space-y-6" data-id="element-2718">
                        <div data-id="element-2719">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-2" data-id="element-2720">
                            Meeting Brief
                          </h3>
                          <p className="text-[#F5F7FA]" data-id="element-2721">
                            Demonstration of our new product features to the
                            client. Focus on the user interface improvements,
                            performance enhancements, and new analytics
                            capabilities. Be prepared to address questions about
                            implementation timeline and support options.
                          </p>
                        </div>
                        <div data-id="element-2722">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2723">
                            Attendees (3)
                          </h3>
                          <div className="space-y-3" data-id="element-2724">
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2725">
                              <div className="flex items-center space-x-3" data-id="element-2726">
                                <div className="w-8 h-8 rounded-full bg-orange-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2727">
                                  TC
                                </div>
                                <div data-id="element-2728">
                                  <div className="font-medium" data-id="element-2729">
                                    Thomas Clark
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2730">
                                    CTO, Client Corp
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2731">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2732" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2733">
                              <div className="flex items-center space-x-3" data-id="element-2734">
                                <div className="w-8 h-8 rounded-full bg-yellow-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2735">
                                  SL
                                </div>
                                <div data-id="element-2736">
                                  <div className="font-medium" data-id="element-2737">Sarah Lee</div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2738">
                                    Product Manager, Client Corp
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2739">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2740" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2741">
                              <div className="flex items-center space-x-3" data-id="element-2742">
                                <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2743">
                                  PB
                                </div>
                                <div data-id="element-2744">
                                  <div className="font-medium" data-id="element-2745">Paul Brown</div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2746">
                                    IT Director, Client Corp
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2747">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2748" />
                                LinkedIn
                              </button>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-2749">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2750">
                            Previous Engagement
                          </h3>
                          <div className="space-y-3" data-id="element-2751">
                            <div className="bg-[#1E2A38] p-3 rounded-lg" data-id="element-2752">
                              <div className="flex items-start space-x-3" data-id="element-2753">
                                <MailIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2754" />
                                <div data-id="element-2755">
                                  <h4 className="font-medium" data-id="element-2756">
                                    Initial Requirements Meeting
                                  </h4>
                                  <p className="text-sm text-[#F5F7FA] text-opacity-70 mt-1" data-id="element-2757">
                                    Thomas expressed concerns about integration
                                    with their existing systems. Sarah
                                    emphasized the need for better reporting
                                    features.
                                  </p>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-50 mt-2" data-id="element-2758">
                                    2 weeks ago
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-2759">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2760">
                            Business Insights
                          </h3>
                          <div className="space-y-3" data-id="element-2761">
                            <div className="flex items-start space-x-3" data-id="element-2762">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2763" />
                              <p className="text-[#F5F7FA]" data-id="element-2764">
                                Client renewed their contract for 3 years last
                                month
                              </p>
                            </div>
                            <div className="flex items-start space-x-3" data-id="element-2765">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2766" />
                              <p className="text-[#F5F7FA]" data-id="element-2767">
                                They're considering expanding usage to 3
                                additional departments
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-end" data-id="element-2768">
                          <button className="bg-[#F5F7FA] bg-opacity-10 hover:bg-opacity-20 text-[#F5F7FA] px-4 py-2 rounded-lg text-sm font-medium" data-id="element-2769">
                            Continue Preparation
                          </button>
                        </div>
                      </div>
                    </div>}
                </div>
                {/* Third meeting card */}
                <div className={`bg-[#1A2331] rounded-lg border ${expandedMeeting === 'meeting3' ? 'border-[#C8F169] border-opacity-30' : 'border-[#F5F7FA] border-opacity-5 hover:border-[#C8F169] hover:border-opacity-30'} transition-all cursor-pointer`} onClick={() => toggleMeeting('meeting3')} data-id="element-2770">
                  <div className="p-5" data-id="element-2771">
                    <div className="flex items-center justify-between" data-id="element-2772">
                      <div className="flex items-center space-x-3" data-id="element-2773">
                        <div className="w-10 h-10 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-sm font-bold" data-id="element-2774">
                          RB
                        </div>
                        <div data-id="element-2775">
                          <div className="font-medium text-lg" data-id="element-2776">
                            Team Weekly Sync
                          </div>
                          <div className="flex items-center text-sm text-[#F5F7FA] text-opacity-60" data-id="element-2777">
                            <ClockIcon className="h-3.5 w-3.5 mr-1" data-id="element-2778" />
                            4:30 PM - 5:30 PM
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#F5F7FA] bg-opacity-10 px-3 py-1.5 rounded-full" data-id="element-2779">
                        <span className="text-xs font-medium text-[#F5F7FA] text-opacity-70" data-id="element-2780">
                          Not Prepared
                        </span>
                      </div>
                    </div>
                  </div>
                  {expandedMeeting === 'meeting3' && <div className="px-5 pb-5 border-t border-[#F5F7FA] border-opacity-10 pt-4" data-id="element-2781">
                      <div className="space-y-6" data-id="element-2782">
                        <div data-id="element-2783">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-2" data-id="element-2784">
                            Meeting Brief
                          </h3>
                          <p className="text-[#F5F7FA]" data-id="element-2785">
                            Regular team sync to discuss weekly progress,
                            address any blockers, and plan for the upcoming
                            week. Each team member will provide updates on their
                            assigned tasks and highlight any issues requiring
                            attention.
                          </p>
                        </div>
                        <div data-id="element-2786">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2787">
                            Attendees (8)
                          </h3>
                          <div className="space-y-3" data-id="element-2788">
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2789">
                              <div className="flex items-center space-x-3" data-id="element-2790">
                                <div className="w-8 h-8 rounded-full bg-blue-400 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2791">
                                  KW
                                </div>
                                <div data-id="element-2792">
                                  <div className="font-medium" data-id="element-2793">Kate Wilson</div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2794">
                                    Team Lead
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2795">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2796" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2797">
                              <div className="flex items-center space-x-3" data-id="element-2798">
                                <div className="w-8 h-8 rounded-full bg-teal-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2799">
                                  JL
                                </div>
                                <div data-id="element-2800">
                                  <div className="font-medium" data-id="element-2801">James Lee</div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2802">
                                    Senior Developer
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2803">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2804" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2805">
                              <div className="flex items-center space-x-3" data-id="element-2806">
                                <div className="w-8 h-8 rounded-full bg-indigo-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2807">
                                  RM
                                </div>
                                <div data-id="element-2808">
                                  <div className="font-medium" data-id="element-2809">
                                    Rachel Moore
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2810">
                                    UX Designer
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2811">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2812" />
                                LinkedIn
                              </button>
                            </div>
                            <button className="flex items-center text-[#C8F169] text-sm" data-id="element-2813">
                              View all 8 attendees
                              <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-2814" />
                            </button>
                          </div>
                        </div>
                        <div data-id="element-2815">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2816">
                            Previous Engagement
                          </h3>
                          <div className="space-y-3" data-id="element-2817">
                            <div className="bg-[#1E2A38] p-3 rounded-lg" data-id="element-2818">
                              <div className="flex items-start space-x-3" data-id="element-2819">
                                <MailIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2820" />
                                <div data-id="element-2821">
                                  <h4 className="font-medium" data-id="element-2822">
                                    Last Week's Sync Summary
                                  </h4>
                                  <p className="text-sm text-[#F5F7FA] text-opacity-70 mt-1" data-id="element-2823">
                                    The team identified bottlenecks in the
                                    development process. James proposed a new
                                    approach to improve workflow efficiency.
                                  </p>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-50 mt-2" data-id="element-2824">
                                    1 week ago
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-2825">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2826">
                            Business Insights
                          </h3>
                          <div className="space-y-3" data-id="element-2827">
                            <div className="flex items-start space-x-3" data-id="element-2828">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2829" />
                              <p className="text-[#F5F7FA]" data-id="element-2830">
                                Sprint velocity increased by 15% in the last
                                cycle
                              </p>
                            </div>
                            <div className="flex items-start space-x-3" data-id="element-2831">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2832" />
                              <p className="text-[#F5F7FA]" data-id="element-2833">
                                Bug reports decreased by 30% following last
                                release
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
              </div>
            </div>
            <div className="bg-[#F5F7FA] bg-opacity-5 p-6 rounded-xl" data-id="element-2834">
              <div className="flex items-center justify-between mb-4" data-id="element-2835">
                <div className="flex items-center space-x-4" data-id="element-2836">
                  <CalendarIcon className="h-6 w-6 text-[#C8F169]" data-id="element-2837" />
                  <h2 className="text-xl font-medium" data-id="element-2838">Tomorrow</h2>
                </div>
                <span className="bg-[#C8F169] bg-opacity-20 px-3 py-1 rounded-full text-sm text-[#C8F169]" data-id="element-2839">
                  2 Meetings
                </span>
              </div>
              <div className="space-y-4" data-id="element-2840">
                {/* Fourth meeting card */}
                <div className={`bg-[#1A2331] rounded-lg border ${expandedMeeting === 'meeting4' ? 'border-[#C8F169] border-opacity-30' : 'border-[#F5F7FA] border-opacity-5 hover:border-[#C8F169] hover:border-opacity-30'} transition-all cursor-pointer`} onClick={() => toggleMeeting('meeting4')} data-id="element-2841">
                  <div className="p-5" data-id="element-2842">
                    <div className="flex items-center justify-between" data-id="element-2843">
                      <div className="flex items-center space-x-3" data-id="element-2844">
                        <div className="w-10 h-10 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-sm font-bold" data-id="element-2845">
                          MS
                        </div>
                        <div data-id="element-2846">
                          <div className="font-medium text-lg" data-id="element-2847">
                            Marketing Strategy Review
                          </div>
                          <div className="flex items-center text-sm text-[#F5F7FA] text-opacity-60" data-id="element-2848">
                            <ClockIcon className="h-3.5 w-3.5 mr-1" data-id="element-2849" />
                            9:30 AM - 10:30 AM
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#F5F7FA] bg-opacity-10 px-3 py-1.5 rounded-full" data-id="element-2850">
                        <span className="text-xs font-medium text-[#F5F7FA] text-opacity-70" data-id="element-2851">
                          Not Prepared
                        </span>
                      </div>
                    </div>
                  </div>
                  {expandedMeeting === 'meeting4' && <div className="px-5 pb-5 border-t border-[#F5F7FA] border-opacity-10 pt-4" data-id="element-2852">
                      <div className="space-y-6" data-id="element-2853">
                        <div data-id="element-2854">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-2" data-id="element-2855">
                            Meeting Brief
                          </h3>
                          <p className="text-[#F5F7FA]" data-id="element-2856">
                            Review of current marketing campaigns and planning
                            for upcoming initiatives. The team will analyze
                            performance metrics, discuss content strategy, and
                            allocate budget for Q4 activities.
                          </p>
                        </div>
                        <div data-id="element-2857">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2858">
                            Attendees (3)
                          </h3>
                          <div className="space-y-3" data-id="element-2859">
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2860">
                              <div className="flex items-center space-x-3" data-id="element-2861">
                                <div className="w-8 h-8 rounded-full bg-pink-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2862">
                                  LT
                                </div>
                                <div data-id="element-2863">
                                  <div className="font-medium" data-id="element-2864">
                                    Lisa Thompson
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2865">
                                    Marketing Director
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2866">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2867" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2868">
                              <div className="flex items-center space-x-3" data-id="element-2869">
                                <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2870">
                                  JR
                                </div>
                                <div data-id="element-2871">
                                  <div className="font-medium" data-id="element-2872">
                                    John Rodriguez
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2873">
                                    Content Manager
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2874">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2875" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2876">
                              <div className="flex items-center space-x-3" data-id="element-2877">
                                <div className="w-8 h-8 rounded-full bg-green-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2878">
                                  AM
                                </div>
                                <div data-id="element-2879">
                                  <div className="font-medium" data-id="element-2880">
                                    Alex Martinez
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2881">
                                    Digital Marketing Specialist
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2882">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2883" />
                                LinkedIn
                              </button>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-2884">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2885">
                            Previous Engagement
                          </h3>
                          <div className="space-y-3" data-id="element-2886">
                            <div className="bg-[#1E2A38] p-3 rounded-lg" data-id="element-2887">
                              <div className="flex items-start space-x-3" data-id="element-2888">
                                <MailIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2889" />
                                <div data-id="element-2890">
                                  <h4 className="font-medium" data-id="element-2891">
                                    Q3 Campaign Analysis
                                  </h4>
                                  <p className="text-sm text-[#F5F7FA] text-opacity-70 mt-1" data-id="element-2892">
                                    The social media campaign exceeded
                                    expectations with 45% higher engagement. The
                                    team needs to discuss scaling this approach
                                    for Q4.
                                  </p>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-50 mt-2" data-id="element-2893">
                                    2 weeks ago
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-2894">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2895">
                            Business Insights
                          </h3>
                          <div className="space-y-3" data-id="element-2896">
                            <div className="flex items-start space-x-3" data-id="element-2897">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2898" />
                              <p className="text-[#F5F7FA]" data-id="element-2899">
                                Social media engagement increased by 45% in Q3
                              </p>
                            </div>
                            <div className="flex items-start space-x-3" data-id="element-2900">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2901" />
                              <p className="text-[#F5F7FA]" data-id="element-2902">
                                Email campaign conversion rate improved to 12.5%
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
                {/* Fifth meeting card */}
                <div className={`bg-[#1A2331] rounded-lg border ${expandedMeeting === 'meeting5' ? 'border-[#C8F169] border-opacity-30' : 'border-[#F5F7FA] border-opacity-5 hover:border-[#C8F169] hover:border-opacity-30'} transition-all cursor-pointer`} onClick={() => toggleMeeting('meeting5')} data-id="element-2903">
                  <div className="p-5" data-id="element-2904">
                    <div className="flex items-center justify-between" data-id="element-2905">
                      <div className="flex items-center space-x-3" data-id="element-2906">
                        <div className="w-10 h-10 rounded-full bg-[#C8F169] flex items-center justify-center text-[#1E2A38] text-sm font-bold" data-id="element-2907">
                          CL
                        </div>
                        <div data-id="element-2908">
                          <div className="font-medium text-lg" data-id="element-2909">
                            Investor Pitch Preparation
                          </div>
                          <div className="flex items-center text-sm text-[#F5F7FA] text-opacity-60" data-id="element-2910">
                            <ClockIcon className="h-3.5 w-3.5 mr-1" data-id="element-2911" />
                            2:00 PM - 3:30 PM
                          </div>
                        </div>
                      </div>
                      <div className="bg-[#F5F7FA] bg-opacity-10 px-3 py-1.5 rounded-full" data-id="element-2912">
                        <span className="text-xs font-medium text-[#F5F7FA] text-opacity-70" data-id="element-2913">
                          Not Prepared
                        </span>
                      </div>
                    </div>
                  </div>
                  {expandedMeeting === 'meeting5' && <div className="px-5 pb-5 border-t border-[#F5F7FA] border-opacity-10 pt-4" data-id="element-2914">
                      <div className="space-y-6" data-id="element-2915">
                        <div data-id="element-2916">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-2" data-id="element-2917">
                            Meeting Brief
                          </h3>
                          <p className="text-[#F5F7FA]" data-id="element-2918">
                            Internal meeting to prepare for the upcoming
                            investor pitch. The team will review financial data,
                            growth metrics, and the presentation deck. Focus
                            will be on refining the narrative and addressing
                            potential investor questions.
                          </p>
                        </div>
                        <div data-id="element-2919">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2920">
                            Attendees (4)
                          </h3>
                          <div className="space-y-3" data-id="element-2921">
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2922">
                              <div className="flex items-center space-x-3" data-id="element-2923">
                                <div className="w-8 h-8 rounded-full bg-purple-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2924">
                                  RH
                                </div>
                                <div data-id="element-2925">
                                  <div className="font-medium" data-id="element-2926">
                                    Richard Hughes
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2927">
                                    CEO
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2928">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2929" />
                                LinkedIn
                              </button>
                            </div>
                            <div className="bg-[#1E2A38] p-3 rounded-lg flex items-center justify-between" data-id="element-2930">
                              <div className="flex items-center space-x-3" data-id="element-2931">
                                <div className="w-8 h-8 rounded-full bg-teal-500 flex items-center justify-center text-[#1E2A38] text-xs font-bold" data-id="element-2932">
                                  DM
                                </div>
                                <div data-id="element-2933">
                                  <div className="font-medium" data-id="element-2934">
                                    Diane Miller
                                  </div>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-60" data-id="element-2935">
                                    CFO
                                  </div>
                                </div>
                              </div>
                              <button className="text-[#C8F169] flex items-center text-sm" data-id="element-2936">
                                <ExternalLinkIcon className="h-4 w-4 mr-1" data-id="element-2937" />
                                LinkedIn
                              </button>
                            </div>
                            <button className="flex items-center text-[#C8F169] text-sm" data-id="element-2938">
                              View all 4 attendees
                              <ChevronRightIcon className="h-4 w-4 ml-1" data-id="element-2939" />
                            </button>
                          </div>
                        </div>
                        <div data-id="element-2940">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2941">
                            Previous Engagement
                          </h3>
                          <div className="space-y-3" data-id="element-2942">
                            <div className="bg-[#1E2A38] p-3 rounded-lg" data-id="element-2943">
                              <div className="flex items-start space-x-3" data-id="element-2944">
                                <MailIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2945" />
                                <div data-id="element-2946">
                                  <h4 className="font-medium" data-id="element-2947">
                                    Initial Pitch Deck Review
                                  </h4>
                                  <p className="text-sm text-[#F5F7FA] text-opacity-70 mt-1" data-id="element-2948">
                                    Richard suggested focusing more on market
                                    opportunity and competitive advantage. Diane
                                    emphasized the need for clear financial
                                    projections.
                                  </p>
                                  <div className="text-xs text-[#F5F7FA] text-opacity-50 mt-2" data-id="element-2949">
                                    1 week ago
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div data-id="element-2950">
                          <h3 className="text-sm font-medium text-[#F5F7FA] text-opacity-70 mb-3" data-id="element-2951">
                            Business Insights
                          </h3>
                          <div className="space-y-3" data-id="element-2952">
                            <div className="flex items-start space-x-3" data-id="element-2953">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2954" />
                              <p className="text-[#F5F7FA]" data-id="element-2955">
                                Company valuation increased by 35% since last
                                funding round
                              </p>
                            </div>
                            <div className="flex items-start space-x-3" data-id="element-2956">
                              <CheckCircleIcon className="h-5 w-5 text-[#C8F169] mt-0.5" data-id="element-2957" />
                              <p className="text-[#F5F7FA]" data-id="element-2958">
                                Monthly recurring revenue grew 22%
                                quarter-over-quarter
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>
              </div>
            </div>
          </div>}
      </main>
    </div>;
}